import React/*, {useEffect, useState}*/ from "react"
// import ReactModal from 'react-modal'
import "./sponabout2021.css"
// import anime from 'animejs/lib/anime.es.js';

const Host = ( { sponsors, description }) => {

    // const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    // const [animation, setAnimation] = useState()
    // const [animationPlayed, setAnimationPlayed] = useState(false)

    // const showLearnMoreModal = () => setLearnMoreModalState(true)
    // const hideLearnMoreModal = () => setLearnMoreModalState(false)


    return (
        <section className="sponabout2021" id="Sponsor-About">
            <div className="containfix">
                    <div>
                        <h1>SPONSOR <span className="aigreen">AI</span> WEEK</h1>
                        <p className="underabout2021">Reach thousands of decision makers and key influencers IT decision makers and influencers across the U.S. public sector and AI community by being a sponsor of AI Week. Sponsorship benefits include thought leadership opportunities, pipeline generation and brand awareness.
                        </p>


                    </div>

            </div>

        </section>

    )
}

export default Host
